import React, { useEffect, useState } from 'react';
export function Header() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-[#050505]/90 backdrop-blur-md py-4' : 'bg-transparent py-6'}`} data-id="element-113">
      <div className="container mx-auto px-4 md:px-6 flex items-center justify-between" data-id="element-114">
        <div className="text-2xl font-bold tracking-tighter text-white" data-id="element-115">
          AI<span className="text-[#c9a84c]" data-id="element-116">.WEB</span>
        </div>

        <nav className="hidden md:flex items-center space-x-8" data-id="element-117">
          {['Benefits', 'Included', 'Pricing', 'FAQ'].map(item => <button key={item} onClick={() => scrollToSection(item.toLowerCase())} className="text-sm font-medium text-gray-300 hover:text-[#c9a84c] transition-colors uppercase tracking-widest" data-id="element-118">
              {item}
            </button>)}
          <button onClick={() => scrollToSection('contact')} className="px-6 py-2 border border-[#c9a84c] text-[#c9a84c] text-sm font-medium rounded hover:bg-[#c9a84c] hover:text-black transition-all duration-300" data-id="element-119">
            CONTACT
          </button>
        </nav>

        {/* Mobile Menu Button - simplified for this implementation */}
        <button className="md:hidden text-white" onClick={() => scrollToSection('contact')} data-id="element-120">
          <span className="sr-only" data-id="element-121">Contact</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-[#c9a84c]" data-id="element-122">
            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" data-id="element-123"></path>
            <polyline points="22,6 12,13 2,6" data-id="element-124"></polyline>
          </svg>
        </button>
      </div>

      {/* Gold accent line at bottom */}
      <div className={`absolute bottom-0 left-0 right-0 h-[1px] bg-gradient-to-r from-transparent via-[#c9a84c] to-transparent opacity-50 transition-opacity duration-300 ${scrolled ? 'opacity-100' : 'opacity-0'}`} data-id="element-125" />
    </header>;
}